import React, { useRef } from "react"
import Slider from "react-slick"
import CarouselType from "../types/carousel.type"
import { StaticImage } from "gatsby-plugin-image"

const CarouselArrow = (props) => {
  const { element, elementStyle, className, style, onClick } = props

  let elementFinalStyle = { ...style, left: elementStyle }
  if (className === "slick-arrow slick-next") {
    elementFinalStyle = { ...style, right: elementStyle }
  }

  return (
    <div className={className} style={elementFinalStyle} onClick={onClick}>
      {element}
    </div>
  )
}

const Carousel = (props: CarouselType) => {
  const sliderRef = useRef<any>()

  const settings = {
    ...props,
    arrows: props.showArrows,
    prevArrow: (
      <CarouselArrow
        element={
          props.arrowsElements ? (
            props.arrowsElements["left"]
          ) : (
            <StaticImage src='../images/left-arrow.png' alt='' />
          )
        }
        elementStyle={props.arrowsPosition && props.arrowsPosition["left"]}
      />
    ),
    nextArrow: (
      <CarouselArrow
        element={
          props.arrowsElements ? (
            props.arrowsElements["right"]
          ) : (
            <StaticImage src='../images/right-arrow.png' alt='' />
          )
        }
        elementStyle={props.arrowsPosition && props.arrowsPosition["right"]}
      />
    ),
    dotsClass: `slick-dots carousel-dots${
      props.dotsOnImages ? " carousel-dots-on-images" : ""
    }`,
    appendDots: (dots) => (
      <div>
        <ul className='flex justify-center items-center space-x-4'>
          {dots}
          {props.seeAll ? props.seeAll : null}
        </ul>
      </div>
    ),
  }

  return (
    <div
      className={`carousel-container z-1${
        props.containerClass ? " " + props.containerClass : ""
      }
      ${props.edgesFade ? " fade-edges" : ""}
      ${props.notActiveDown ? " not-active-down" : ""}`}
    >
      <Slider ref={sliderRef} {...settings} lazyLoad={props.lazyLoad || "ondemand"}>
        {props.data}
      </Slider>
    </div>
  )
}

export default Carousel
